
export default {
  // Airport details
  "rank": "Posición",
  "hand_check_rate": "Tasa de Revisión Manual",
  "reviews": "Reseñas",
  "loading_airport": "Cargando detalles del aeropuerto...",
  "airport_not_found": "Aeropuerto no encontrado",
  "airport_reviews": "Reseñas de Aeropuerto",
  "no_reviews_yet_share": "Aún no hay reseñas",
  "share_film_community": "¡Comparte tu experiencia con la comunidad de fotografía!",
  "add_review_button": "Añadir Reseña",
  "back_to_lenses": "Volver a Lentes",
  "back_to_cameras": "Volver a Cámaras",
  "failed_load_lens": "Error al cargar detalles del lente",
  "lens_not_found": "Lente no encontrado",
  "favorite_airports": "Aeropuertos Favoritos",
  "no_favorite_airports": "Aún no hay aeropuertos favoritos",
  "user_favorites": "Favoritos del Usuario",
  "manage_favorites": "Gestionar Favoritos",
  "remove_from_favorites": "Eliminar de Favoritos",
  "add_to_favorites": "Añadir a Favoritos",
  "airport_added_favorites": "Aeropuerto añadido a favoritos",
  "airport_removed_favorites": "Aeropuerto eliminado de favoritos",
};
